<opac-dialog #dialog>
  <h3 slot="header">{{ title() | translate }}</h3>
  <p *ngIf="shouldShowGuidelinesText()">{{ guidelinesText() }}</p>

  <form *ngIf="requireChangePassword()" [formGroup]="changePasswordForm">
    <opac-password-input
      formControlName="newPassword"
      name="new-password"
      [invalid]="newPasswordControl | invalidControl">
      {{ 'user.details.newPassword' | translate }}
      <span
        *ngIf="newPasswordControl | invalidControl"
        slot="error">
        {{ 'login.passwordFormat' | translate }}
      </span>
    </opac-password-input>

    <opac-password-input
      formControlName="confirmNewPassword"
      name="confirm-new-password"
      [invalid]="confirmNewPasswordControl | invalidControl">
      {{ 'user.fields.confirmPassword' | translate }}
      <span *ngIf="confirmNewPasswordControl | invalidControl" slot="error">
        {{ 'login.passwordNotMatching' | translate }}
      </span>
    </opac-password-input>
  </form>

  <opac-text-input *ngIf="requireChangeMail()"
    [formControl]="emailFormControl"
    [invalid]="emailFormControl | invalidControl">
    {{ 'user.fields.email' | translate }}
    <span *ngIf="emailFormControl | invalidControl" slot="error">
      {{ 'user.account.invites.error.email' | translate }}
    </span>
  </opac-text-input>

  <div class="actions" slot="actions">
    <opac-checkbox *ngIf="showCheckBox()" [ngModel]="checked()" (ngModelChange)="checked.set($event)">
      {{ 'signup.terms' | translate }}
      <a [href]="termsUrl()" target="_blank" rel="noopener">
        {{ 'signup.termsUrl' | translate }}
        <opac-icon icon="external_link"></opac-icon>
      </a>
    </opac-checkbox>

    <opac-button
      [disabled]="(showCheckBox() && !checked()) || (requireChangePassword() && !changePasswordForm.valid) || (requireChangeMail() && !emailFormControl.valid)"
      (click)="accept()">
      {{ 'general.accept' | translate }}
    </opac-button>
  </div>
</opac-dialog>
